// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-histogram-item{min-width:2.8rem;min-height:2.2rem;border-color:#bbbcd4;background-color:#fff;color:#0c0243}.bw-histogram-item:hover:not(.bw-isCheapest):not(.bw-selected) .bw-date{color:#494989}.bw-noFlight{border:none;background-color:rgba(0,0,0,0);box-shadow:none}.bw-noFlight .bw-icon{width:.8rem;height:.8rem}.bw-noFlight:hover{color:#494989}.bw-noFlight:hover .bw-icon{color:#494989}.bw-isCheapest:not(.bw-noFlight){background-color:#7e1f89;border-color:#7e1f89;color:#fff}.bw-isCheapest:not(.bw-noFlight):hover:not(.bw-selected){background-color:#8f2591;border-color:#8f2591}.bw-selected:not(.bw-noFlight){background-color:#0c0243;border-color:#0c0243;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"histogram-item": "bw-histogram-item",
	"isCheapest": "bw-isCheapest",
	"selected": "bw-selected",
	"date": "bw-date",
	"noFlight": "bw-noFlight",
	"icon": "bw-icon"
};
module.exports = ___CSS_LOADER_EXPORT___;
